export const authRoutes = [
  {
    path: "/welcome",
    name: "welcome",
    meta: { layout: "empty", allowAnonymous: true },
    component: () => import(/* webpackChunkName: "auth" */ "./WelcomeView.vue"),
  },
];
